export const PUBLIC_USER_API_END_POINT = process.env.RAZZLE_PUBLIC_USER_API_END_POINT || 'public-users'
export const SOCIAl_OAUTH_ENABLED = process.env.RAZZLE_SOCIAl_OAUTH_ENABLED || false
export const REDIRECT_AFTER_REGISTER = process.env.RAZZLE_REDIRECT_AFTER_REGISTER || false


export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
export const BASE_URL = process.env.RAZZLE_BASE_URL
export const GOOGLE_OAUTH_KEY = process.env.RAZZLE_GOOGLE_OAUTH_KEY
export const FACEBOOK_OAUTH_KEY = process.env.RAZZLE_FACEBOOK_OAUTH_KEY
